export default {
    inject: {
        parentComponent: { default: null },
    },
    created() {
        this.parentComponent.$on('resetFilters', this.resetFilters);
    },
    beforeDestroy() {
        this.parentComponent.$off('resetFilters', this.resetFilters);
    },
    computed: {
        spaceId() {
            return this.$store.state.space.currentSpaceId;
        },
        timeRange() {
            return this.parentComponent?.timeRange || null;
        },
        timeRangeString() {
            return JSON.stringify(this.timeRange || {});
        },
    },
};
